import * as KatalMetrics from '@amzn/katal-metrics';
import { createMetricsPublisher } from '@amzn/katal-metrics-mons';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

// Browser-compatible environment detection
const getNodeEnv = (): string => {
    // Check if process exists (Node.js environment)
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
        return process.env.NODE_ENV;
    }

    // Browser environment fallback - assume production unless in development
    // You can detect development by checking for localhost or other dev indicators
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
        return 'development';
    }

    return 'production';
};

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
    const nodeEnv = getNodeEnv();

    // Note that if we are in production or SERVER_MODE 'mons' we auto-configure before running this function.
    // So for Mons apps these configurations are just for unit tests and local server tests.
    if (nodeEnv === 'test') {
        const metricsDriver = new KatalMetricsDriverArrayCollector();
        //  Attach to global window object so tests can see it
        (window as any).metricsDriver = metricsDriver;
        return metricsDriver;
    } else if (nodeEnv !== 'production') {
        return new KatalMetricsDriverConsoleLogJson();
    } else {
        return new KatalMetricsDriverSushi.Builder()
            .withDomainRealm('test', 'USAmazon')
            .withErrorHandler(metricsConsoleErrorHandler)
            .build();
    }
};

const makePublisher = (): KatalMetrics.Publisher => {
    if (!SERVER_MODE || SERVER_MODE === 'mons') {
        return createMetricsPublisher();
    }
    // Otherwise we are running a test server outside of Mons so cannot use KatalMetricsMons to auto-configure.
    return makeProdPublisher();
};

// Creating a separate metrics publisher with 'prod' domain to publish pageView metrics.
const makeProdPublisher = () : KatalMetrics.Publisher => {
    const metricsDriver = makeMetricsDriver();
    const initialMetricsContext = new KatalMetrics.Context.Builder()
      .withSite('SellerCentral')
      .withServiceName('KatalMonsReactApplication')
      .build();
    return new KatalMetrics.Publisher(
      metricsDriver,
      metricsConsoleErrorHandler,
      initialMetricsContext);
}

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
